<ion-content>
  <ion-toolbar class="toolbarSectionName"> {{texto}} </ion-toolbar>
  <iframe #iframe class="iframeFullScreen nodisplay" (load)="helpageload($event)" [src]="scrHelp"></iframe>
  <codere-footer></codere-footer>
</ion-content>
